<template>
  <div>
    <v-tour :callbacks="callbacks" name="AssetsWithDataTour" :steps="steps"></v-tour>
  </div>
</template>
<script>
export default {
  name: 'my-tour',
  data () {
    return {
      callbacks: {
        onSkip: () => {
          console.log('skipping')
          this.$emit('stopShowingThisTour')
        },
        onFinish: () => {
          console.log('finished')
          this.$emit('stopShowingThisTour')
        },
      },
      steps: [
        {
          target: '#start_crawl_button',  // We're using document.querySelector() under the hood
          header: {
            title: 'Start by crawling',
          },
          content: `
            The easiest way to get data into Content Chimera is to crawl.
            Just click Start Crawling to get started.
          `,
          params: {
            placement: 'top' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
        {
          target: '#import_box',  // We're using document.querySelector() under the hood
          header: {
            title: 'Or import',
          },
          content: `
            You can also import data from another source, such as Screaming Frog.
          `,
          params: {
            placement: 'start-right' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
        {
          target: '#data_file',  // We're using document.querySelector() under the hood
          header: {
            title: 'Upload CSV',
          },
          content: `
            The first step is to upload the CSV from the other data source. Content Chimera
            only accepts CSVs, but it will accept a CSV from any source.
          `,
          params: {
            placement: 'right' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
        {
          target: '#data_source',  // We're using document.querySelector() under the hood
          header: {
            title: 'Select data source',
          },
          content: `
            Next you select the data source from the list
          `,
          params: {
            placement: 'right' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
        {
          target: '#data_start',  // We're using document.querySelector() under the hood
          header: {
            title: 'Start Importing',
          },
          content: `
            The last step for importing from another source is to click Start Importing.
          `,
          params: {
            placement: 'bottom' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
        {
          target: '#start_crawl_button',  // We're using document.querySelector() under the hood
          header: {
            title: '90% of the time, just click this button',
          },
          content: `
            Remember: in most cases, you'll want to just click Start Crawling.
          `,
          params: {
            placement: 'top' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
      ]
    }
  },
  mounted: function () {
    this.$tours['AssetsWithDataTour'].start()
  }
}
</script>